module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_1024.775cb3e9.webp";